<template>
 <ul class="sidebar-menu">
   <li class="header" v-if="idioma === 'DE'">Bereiche</li>
   <li class="header" v-else-if="idioma === 'EN'">Areas</li>
   <li class="header" v-else-if="idioma === 'ES'">Áreas</li>
   <li class="header" v-else>Áreas</li>
   <router-link tag="li" class="pageLink" to="/">
      <a>
        <i class="fa fa-desktop"></i>
        <span class="page" v-if="idioma === 'DE'">Hauptsächlich</span>
        <span class="page" v-else-if="idioma === 'EN'">Home</span>
        <span class="page" v-else-if="idioma === 'ES'">Principal</span>
        <span class="page" v-else>Principal</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/manutencao">
      <a>
        <i class="fa ion-android-settings"></i>
        <span class="page" v-if="idioma === 'DE'">Wartung</span>
        <span class="page" v-else-if="idioma === 'EN'">Maintenance</span>
        <span class="page" v-else-if="idioma === 'ES'">Mantenimiento</span>
        <span class="page" v-else>Manutenção</span>
      </a>
    </router-link>
    <li class="treeview">
      <a href="#">
        <i class="fa ion-stats-bars"></i>
        <span class="page" v-if="idioma === 'DE'">Grafik</span>
        <span class="page" v-else-if="idioma === 'EN'">Graphics</span>
        <span class="page" v-else-if="idioma === 'ES'">Gráficos</span>
        <span class="page" v-else>Gráficos</span>
        <span class="pull-right-container">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/graficos-geracao">
              <a>
                <span class="page" v-if="idioma === 'DE'"> Energieerzeugung</span>
                <span class="page" v-else-if="idioma === 'EN'"> Energy Generation</span>
                <span class="page" v-else-if="idioma === 'ES'"> Generacion de energia</span>
                <span class="page" v-else> Geração de Energia</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/graficos-eficiencia">
              <a>
                <span class="page" v-if="idioma === 'DE'"> Effizienz</span>
                <span class="page" v-else-if="idioma === 'EN'"> Efficiency</span>
                <span class="page" v-else-if="idioma === 'ES'"> Eficiencia</span>
                <span class="page" v-else> Eficiência</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/graficos-gerais">
              <a>
                <span class="page" v-if="idioma === 'DE'"> Allgemeines</span>
                <span class="page" v-else-if="idioma === 'EN'"> General</span>
                <span class="page" v-else-if="idioma === 'ES'"> General</span>
                <span class="page" v-else> Gerais</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/graficos-material">
              <a>
                <span class="page" v-if="idioma === 'DE'"> Material</span>
                <span class="page" v-else-if="idioma === 'EN'"> Material</span>
                <span class="page" v-else-if="idioma === 'ES'"> Material</span>
                <span class="page" v-else> Material</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/graficos-acumulados">
              <a>
                <span class="page" v-if="idioma === 'DE'"> Kumuliert pro Tag</span>
                <span class="page" v-else-if="idioma === 'EN'"> Accumulated per day</span>
                <span class="page" v-else-if="idioma === 'ES'"> Acumulado por día</span>
                <span class="page" v-else> Acumulados por dia</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
    </li>
   <router-link tag="li" class="pageLink" to="/usuario">
     <a>
       <i class="fa fa-user"></i>
       <span class="page" v-if="idioma === 'DE'">Nutzer</span>
        <span class="page" v-else-if="idioma === 'EN'">User</span>
        <span class="page" v-else-if="idioma === 'ES'">Usuario</span>
        <span class="page" v-else>Usuário</span>
     </a>
   </router-link>
   <router-link tag="li" class="pageLink" to="/logout">
     <a>
       <i class="fa fa-sign-out"></i>
       <span class="page" v-if="idioma === 'DE'">Ausgehen</span>
        <span class="page" v-else-if="idioma === 'EN'">Exit</span>
        <span class="page" v-else-if="idioma === 'ES'">Salir</span>
        <span class="page" v-else>Sair</span>
     </a>
   </router-link>
 </ul>
</template>
<script>
import config from '../../config'

export default {
  name: 'SidebarMenu',
  data () {
    return {
      idioma: config.idioma
    }
  }
}
</script>
<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

.treeview-title {
  z-index: 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?60dafb48